<template>
	<v-snackbar :timeout='-1' centered color='secondary' flat top :value='visible'>
		<span class='black--text mr-2'>You have unsaved changes</span>

		<v-btn @click='save' color='primary' large tile>Save changes</v-btn>
		<v-btn @click='revert' color='primary' text>Revert</v-btn>
	</v-snackbar>
</template>

<script>
export default {
	name: 'ChangeController',
	props: {
		visible: Boolean
	},
	timeout: 0,
	data() {
		return { 
			timeout: 0, 
		} 
	},
	methods: {
		save() {
			this.$emit('save')
		},
		revert() {
			this.$emit('revert')
		},
	},
}
</script>